import styles from './ResizableHandles.module.css';

/**
 * Renderiza handles de resize estilo Windows em volta de um modal.
 * Pareado com useResizableModal — passe a função `iniciarResize` do hook.
 *
 * Uso:
 *   const { modalRef, modalStyle, iniciarResize } = useResizableModal({ storageKey: 'meu' });
 *   <div ref={modalRef} style={modalStyle}>
 *     <ResizableHandles onResize={iniciarResize} />
 *     ...
 *   </div>
 *
 * IMPORTANTE: o elemento que contém os handles precisa ter `position: relative`.
 */
export default function ResizableHandles({ onResize }) {
    if (!onResize) return null;
    return (
        <>
            <div className={`${styles.handle} ${styles.left}`}        onMouseDown={e => onResize('l',  e)} />
            <div className={`${styles.handle} ${styles.right}`}       onMouseDown={e => onResize('r',  e)} />
            <div className={`${styles.handle} ${styles.bottom}`}      onMouseDown={e => onResize('b',  e)} />
            <div className={`${styles.handle} ${styles.bottomLeft}`}  onMouseDown={e => onResize('bl', e)} />
            <div className={`${styles.handle} ${styles.bottomRight}`} onMouseDown={e => onResize('br', e)} />
        </>
    );
}
